import API from '../api/api'

export const SET_PROVIDERS = 'SET_PROVIDERS'
export const DISCONNECT_PROVIDER = 'DISCONNECT_PROVIDER'
export const UPDATE_PROVIDER_LOCATION = 'UPDATE_PROVIDER_LOCATION'
export const SET_NOT_REPLIED_COUNT = 'SET_NOT_REPLIED_COUNT'
export const SET_RECENT_REVIEWS = 'SET_RECENT_REVIEWS'
export const SET_REFETCH_RECENT_REVIEWS = 'SET_REFETCH_RECENT_REVIEWS'
export const DELETE_REPLY = 'DELETE_REPLY'

const initialState = {
  providers: [],
  recentReviews: [],
  notRepliedCount: 0,
  refetchRecentReviews: false,
}

const reputationManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PROVIDERS:
      return { ...state, providers: action.payload }
    case DISCONNECT_PROVIDER:
      return {
        ...state,
        providers: state.providers.map((p) =>
          p.provider === action.payload ? { ...p, available: false, locationName: '' } : p,
        ),
      }
    case UPDATE_PROVIDER_LOCATION:
      return {
        ...state,
        providers: state.providers.map((p) =>
          p.provider === action.payload.provider
            ? { ...p, locationName: action.payload.locationName }
            : p,
        ),
      }
    case SET_NOT_REPLIED_COUNT:
      return { ...state, notRepliedCount: action.payload }
    case SET_RECENT_REVIEWS:
      return { ...state, recentReviews: action.payload }
    case SET_REFETCH_RECENT_REVIEWS:
      return { ...state, refetchRecentReviews: action.payload }
    case DELETE_REPLY:
      return {
        ...state,
        recentReviews: state.recentReviews.map((review) =>
          review.id === action.reviewId
            ? { ...review, replies: review.replies.filter((reply) => reply.id !== action.replyId) }
            : review,
        ),
      }
    default:
      return state
  }
}

export const setProviders = (payload) => {
  return {
    type: SET_PROVIDERS,
    payload,
  }
}

export const setNotRepliedCount = (count) => {
  return {
    type: SET_NOT_REPLIED_COUNT,
    payload: count,
  }
}

export const setRecentReviews = (reviews) => {
  return {
    type: SET_RECENT_REVIEWS,
    payload: reviews,
  }
}

export const setRefetchRecentReviews = (value) => (dispatch) => {
  dispatch({
    type: SET_REFETCH_RECENT_REVIEWS,
    payload: value,
  })
}

export const fetchProviders = (buildingId) => {
  return (dispatch) => {
    return API.getBuildingProviders(buildingId)
      .then((res) => {
        dispatch(setProviders(res.data))
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  }
}

export const updateProviderLocation = (buildingId, provider, locationId, locationName) => {
  return (dispatch) => {
    return API.updateProviderLocation(buildingId, provider, locationId, locationName)
      .then((res) => {
        dispatch({
          type: UPDATE_PROVIDER_LOCATION,
          payload: { provider, locationName },
        })
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  }
}

export const disconnectProvider = (buildingId, provider) => {
  return (dispatch) => {
    return API.disconnectProvider(buildingId, provider)
      .then((res) => {
        dispatch({ type: DISCONNECT_PROVIDER, payload: provider })
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  }
}

export const fetchNotRepliedCount = (buildingId, filter) => {
  return (dispatch) => {
    return API.getReputationReviewNotRepliedCount(buildingId, filter)
      .then((res) => {
        dispatch(setNotRepliedCount(res.data.count))
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  }
}

export const fetchRecentReviews = (buildingId, filter) => {
  return (dispatch) => {
    return API.getReputationReviews(buildingId, filter)
      .then((res) => {
        const { reviews = [] } = res.data
        dispatch(setRecentReviews(reviews))
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  }
}

export const deleteReply = (reviewId, replyId) => {
  return (dispatch) => {
    return API.deleteReputationReviewReply(reviewId, replyId)
      .then((res) => {
        dispatch({ type: DELETE_REPLY, reviewId, replyId })
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  }
}

export const selectProviders = (state) => state.reputationManagement.providers

export const hasConnectedProviders = (state) =>
  state.reputationManagement.providers.length > 0 &&
  state.reputationManagement.providers.some((p) => p.available)

export const hasGoogleBusinessLocation = (state) =>
  state.reputationManagement.providers.some(
    (p) => p.provider === 'google' && p.available && !!p.locationName,
  )

export const getNotRepliedCount = (state) => state.reputationManagement.notRepliedCount

export const getRecentReviews = (state) => state.reputationManagement.recentReviews

export const getRefetchRecentReviews = (state) => state.reputationManagement.refetchRecentReviews

export default reputationManagementReducer
